/* eslint-disable */

import { useState, useCallback, useEffect } from 'react';
import { message } from 'antd';
import axios from 'axios';

export const useProductItemList = ({
  app_hostname,
  permitdata,
  page = 1,
  pageSize = 50,
  search = '',
  categoryId = '',
}) => {
  const [productitem_list, setProductItem_List] = useState([]);
  const [productcategory_list, setProductCategory_List] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [categoriesLoaded, setCategoriesLoaded] = useState(false);

  const loadCategories = useCallback(async () => {
    try {
      const formData = new FormData();
      const response = await axios.post(`${app_hostname}/api/product/category/getlist`, formData, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + permitdata.token,
        },
      });
      if (response.data.status === 'OK') {
        setProductCategory_List(response.data.products || []);
      }
    } catch (err) {
      message.error(err.message || 'โหลดหมวดหมู่ไม่สำเร็จ');
    } finally {
      setCategoriesLoaded(true);
    }
  }, [app_hostname, permitdata.token]);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page: String(page),
        limit: String(pageSize),
        search: search || '',
      });
      const formData = new FormData();
      const effectiveCategory =
        categoryId && categoryId !== 'all' ? categoryId : '';
      if (effectiveCategory) {
        formData.append('productcategory_id', effectiveCategory);
      }

      const response = await axios.post(
        `${app_hostname}/api/product/item/getlist?${params.toString()}`,
        formData,
        {
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + permitdata.token,
          },
        },
      );

      if (response.data.status !== 'OK') {
        message.error(response.data.message || 'เกิดข้อผิดพลาดในการโหลดข้อมูล');
        return;
      }

      setProductItem_List(response.data.products_item || []);
      setTotal(response.data.total ?? 0);
      if (Array.isArray(response.data.products_category) && response.data.products_category.length > 0) {
        setProductCategory_List(response.data.products_category);
      }
    } catch (err) {
      message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
    } finally {
      setLoading(false);
    }
  }, [app_hostname, permitdata.token, page, pageSize, search, categoryId]);

  useEffect(() => {
    loadCategories();
  }, [loadCategories]);

  useEffect(() => {
    if (!categoriesLoaded) return;
    reload();
  }, [reload, categoriesLoaded]);

  return {
    productitem_list,
    productcategory_list,
    total,
    loading,
    reload,
  };
};
